module.exports = __webpack_public_path__ + "img/jordbruk_paavirkning_hymo.755a38e5.jpg";